import { useDialogs } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { PasswordField } from '@mews-commander/form';
import { LocalizedText } from '@mews/framework';
import { Button, Dialog, Stack } from '@optimus-web/core';

import { SuccessDialog } from '../SuccessDialog';
import { PinEnableFormFields, usePinEnableDialogForm } from './usePinEnableDialogForm';
import { PIN_ENABLE_FORM_ID } from './constants';

export const PIN_ENABLE_DIALOG_NAME = 'pinEnable';

export const PinEnableDialog = ({ password }: { password: string }) => {
    const { closeDialog } = useDialogs();

    const { renderFormContent, isSuccess, isLoading } = usePinEnableDialogForm(password);

    const handleCloseDialog = () => closeDialog(PIN_ENABLE_DIALOG_NAME);

    return isSuccess ? (
        <SuccessDialog
            onClose={handleCloseDialog}
            descriptionTextKey={TextKey.PinReadyDescription}
            titleTextKey={TextKey.PinReadyTitle}
        />
    ) : (
        <Dialog
            active
            onClose={handleCloseDialog}
            title={<LocalizedText textKey={TextKey.PinCreate} />}
            size="small"
            loading={isLoading}
            footer={{
                secondary: (
                    <Button type="button" onClick={handleCloseDialog} variant="tertiary">
                        <LocalizedText textKey={TextKey.Cancel} />
                    </Button>
                ),
                primary: (
                    <Button type="submit" form={PIN_ENABLE_FORM_ID} variant="primary">
                        <LocalizedText textKey={TextKey.Create} />
                    </Button>
                ),
            }}
        >
            {renderFormContent(
                <Stack vertical spacing="200">
                    <PasswordField
                        name={PinEnableFormFields.Pin}
                        helper={<LocalizedText textKey={TextKey.PinRequirements} />}
                        hasPasswordVisibilityToggle
                        label={<LocalizedText textKey={TextKey.Pin} />}
                        required
                        autoComplete="off"
                    />
                    <PasswordField
                        name={PinEnableFormFields.ConfirmPin}
                        hasPasswordVisibilityToggle
                        label={<LocalizedText textKey={TextKey.PinConfirm} />}
                        required
                        autoComplete="off"
                    />
                </Stack>
            )}
        </Dialog>
    );
};
